import { render, staticRenderFns } from "./DistorationFactorCurrent.vue?vue&type=template&id=295fc172&scoped=true&"
import script from "./DistorationFactorCurrent.vue?vue&type=script&lang=js&"
export * from "./DistorationFactorCurrent.vue?vue&type=script&lang=js&"
import style0 from "./DistorationFactorCurrent.vue?vue&type=style&index=0&id=295fc172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295fc172",
  null
  
)

export default component.exports